/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Box, Flex, Text } from '@tishman/components';
import React from 'react';

interface HeroSectionProps {
  title: string;
  subtitle: string;
}

const HeroSection = ({
  title,
  subtitle,
}: HeroSectionProps): React.JSX.Element => (
  <Box
    sx={{
      border: '2px solid #A88362',
      mx: [3, 5],
      my: 5,
      padding: ['20px', 3],
    }}
  >
    <Flex
      sx={{
        border: '2px solid #A88362',
        alignItems: 'center',
        flexDirection: 'column',
        paddingX: [2, 4],
        paddingY: [5, 6],
        textAlign: 'center',
      }}
    >
      <Text
        sx={{
          fontSize: [6, 7],
          fontWeight: 'medium',
          lineHeight: ['34px', '52px'],
          maxWidth: '602px',
          pb: 2,
          variant: 'heading',
        }}
      >
        {title}
      </Text>
      <Text
        sx={{
          fontSize: 2,
          maxWidth: '602px',
          pt: 3,
          px: [4, 0],
        }}
        variant="mediumP"
      >
        {subtitle}
      </Text>
    </Flex>
  </Box>
);

export default HeroSection;
